import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "대표이미지"),
    /*#__PURE__*/_createVNode("th", null, "파트너스 이름"),
    /*#__PURE__*/_createVNode("th", null, "제목"),
    /*#__PURE__*/_createVNode("th", null, "조황일자"),
    /*#__PURE__*/_createVNode("th", null, "게시일시"),
    /*#__PURE__*/_createVNode("th", null, "상세보기")
  ])
], -1)
const _hoisted_7 = { class: "col-md-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["card", { loading: _ctx.loading }]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("table", _hoisted_5, [
              _hoisted_6,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fishingResultList, (result) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: result.data_id
                  }, [
                    _createVNode("td", _hoisted_7, [
                      _createVNode("img", {
                        src: result.image_url + '?w=200',
                        height: "100"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("td", null, _toDisplayString(result.partners_profile_nm), 1),
                    _createVNode("td", null, _toDisplayString(result.title), 1),
                    _createVNode("td", null, _toDisplayString(result.fishing_date_view), 1),
                    _createVNode("td", null, _toDisplayString(result.create_date), 1),
                    _createVNode("td", null, [
                      _createVNode("button", {
                        class: "btn btn-primary",
                        type: "button",
                        onClick: ($event: any) => (_ctx.viewDetail(result.data_id))
                      }, " 상세보기 ", 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}